export default "__VITE_ASSET__Es_Sohwf__"